import { Instagram, MapPin, Navigation, MessageCircle, Mail } from "lucide-react";
import { waLink } from "@/lib/format";

export function Location({ contact }) {
  return (
    <section id="ubicacion" className="py-16 sm:py-24" data-testid="location-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-5 gap-10 items-center">
        <div className="lg:col-span-2">
          <p className="eyebrow">Ubicación</p>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">Cómo llegar a Rachel Lodge</h2>
          <p className="mt-5 flex gap-3 text-muted-foreground"><MapPin className="h-5 w-5 shrink-0 text-[#5E6B52]" />{contact.address}</p>
          <div className="mt-8 flex flex-wrap gap-3">
            <a href={contact.maps_link} target="_blank" rel="noreferrer" data-testid="directions-btn"
              className="inline-flex items-center gap-2 rounded-full bg-[#5E6B52] text-white px-6 py-3 font-semibold transition-colors hover:bg-[#4A5540]">
              <Navigation className="h-4 w-4" /> Cómo llegar
            </a>
            <a href={waLink(contact.whatsapp, "Hola Rachel Lodge, quisiera hacer una consulta.")} target="_blank" rel="noreferrer" data-testid="location-whatsapp-btn"
              className="inline-flex items-center gap-2 rounded-full border border-[#5E6B52] text-[#5E6B52] px-6 py-3 font-semibold transition-colors hover:bg-[#E9EFE6]">
              <MessageCircle className="h-4 w-4" /> WhatsApp
            </a>
            <a href={contact.instagram_url} target="_blank" rel="noreferrer" data-testid="location-instagram-btn"
              className="inline-flex items-center gap-2 rounded-full border border-border px-6 py-3 font-semibold transition-colors hover:bg-[#F3EDE2]">
              <Instagram className="h-4 w-4" /> Instagram
            </a>
          </div>
        </div>
        <div className="lg:col-span-3 rounded-3xl overflow-hidden border border-border aspect-[4/3] lg:aspect-[16/11]">
          <iframe title="Mapa Rachel Lodge" src={contact.maps_embed_url} className="w-full h-full" loading="lazy"
            referrerPolicy="no-referrer-when-downgrade" data-testid="google-map" />
        </div>
      </div>
    </section>
  );
}

export function Footer({ contact, title }) {
  return (
    <footer className="bg-[#1F2421] text-[#E5DCCB] py-14" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-3 gap-10">
        <div>
          <p className="font-serif text-3xl text-[#FAF7F2]">{title}</p>
          <p className="mt-3 text-sm opacity-80">{contact.address}</p>
        </div>
        <div className="flex flex-col gap-2 text-sm">
          <a href="#reservar" className="hover:text-white">Reservar</a>
          <a href="#politicas" className="hover:text-white">Políticas de reserva</a>
          <a href="/admin" className="hover:text-white" data-testid="footer-admin-link">Administración</a>
        </div>
        <div className="flex flex-col gap-2 text-sm">
          <a href={contact.instagram_url} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white"><Instagram className="h-4 w-4" />Instagram</a>
          <a href={waLink(contact.whatsapp)} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white"><MessageCircle className="h-4 w-4" />WhatsApp</a>
          {contact.email && <a href={`mailto:${contact.email}`} className="flex items-center gap-2 hover:text-white"><Mail className="h-4 w-4" />{contact.email}</a>}
        </div>
      </div>
      <p className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10 text-xs opacity-60">© {new Date().getFullYear()} {title}. Valle Alegre, Quintero, Chile.</p>
    </footer>
  );
}

export function WhatsAppFloat({ phone }) {
  return (
    <a href={waLink(phone, "Hola Rachel Lodge, quisiera hacer una consulta.")} target="_blank" rel="noreferrer"
      data-testid="whatsapp-float-btn" aria-label="Escríbenos por WhatsApp"
      className="fixed bottom-5 right-5 z-50 h-14 w-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-xl transition-transform hover:scale-110">
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" />
      <MessageCircle className="h-7 w-7 relative" />
    </a>
  );
}
